export default "__VITE_ASSET__d077aa93__"